import { createSlice } from "@reduxjs/toolkit";

import { REDUX_STATUS } from "constants/status";
import { getBlockUsers, getStripeSubscription, getSubscriptionHistory } from "./actions";
import { IUserSettingState } from "./types";

const initialState: IUserSettingState = {
  status: REDUX_STATUS.INITIAL,
  stripeSubscription: null,
  subscriptionHistory: null,
  blockUsers: null,
  error: null
};

export const userSettingSlice = createSlice({
  name: "userSetting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get stripe subscription
      .addCase(getStripeSubscription.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getStripeSubscription.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.stripeSubscription = action.payload;
      })
      .addCase(getStripeSubscription.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Get subscription history
      .addCase(getSubscriptionHistory.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getSubscriptionHistory.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.subscriptionHistory = action.payload;
      })
      .addCase(getSubscriptionHistory.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Get block users
      .addCase(getBlockUsers.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getBlockUsers.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.blockUsers = action.payload;
      })
      .addCase(getBlockUsers.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      });
  }
});

export default userSettingSlice.reducer;
